import { useFormik } from 'formik';
import { useTranslation } from 'next-i18next';
import { FormEvent, useState } from 'react';

import { Alert } from '@boss/ui';
import { Presence } from '@boss/ui';

import { useSaveSubscription } from '../../client-queries';
import { useForm } from '../../hooks';
import { FormValues } from '../DynamicForm';
import FormFieldMapper, { FormField } from '../Mappers/FormFieldMapper';

const SubscribeForm = () => {
  const { t } = useTranslation('forms');

  const { mutate: submitForm, isLoading: isSubmitting } = useSaveSubscription();
  const { generateValidationSchema, getInitialValues, verifyRecaptcha } = useForm();
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const fields: FormField[] = [
    {
      label: '',
      required: false,
      inputClassName: 'pl-3.75 pr-14.5 h-12 w-full rounded-lg text-black outline-none',
      name: 'email',
      validationType: 'email',
      type: 'input',
      placeholder: t('fields.subscribeNewsletterPlaceholder') || '',
    },
  ];

  const formik = useFormik<FormValues>({
    initialValues: getInitialValues(fields),
    validationSchema: generateValidationSchema(fields),
    onSubmit: (vals: FormValues) =>
      submitForm(
        { email: (vals.email as string) ?? '', subscribeToNewsletter: true },
        {
          onSuccess: () => setShowSuccessMessage(true),
        },
      ),
  });

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const isValid = await verifyRecaptcha();

    if (isValid) {
      formik.handleSubmit(e);
    }
  };

  if (showSuccessMessage) {
    return (
      <Presence className="" id="subscribe-form-success-message-presence" visible>
        <Alert className="p-0" iconSize="xl" title={t('success.title') ?? ''} type="confirm">
          {t('success.subtitle')}
        </Alert>
      </Presence>
    );
  }

  return (
    <form className="w-full" onSubmit={handleSubmit}>
      <div className="flex w-full flex-col">
        <label className="h4 pb-1" htmlFor="subscribeForm">
          {t('fields.subscribeNewsletterAlt')}
        </label>
        <p className="pb-6 text-sm">{t('fields.subscribeNewsletterIncentive')}</p>
        <div className="flex">
          <FormFieldMapper className="-mr-12" field={fields[0]} formik={formik} />
          <button
            className="bg-subscribeForm-submit-btn-bg rounded-38 duration-400 ease ml-auto inline-block h-12 whitespace-nowrap px-6 py-1.5 text-xl text-white transition"
            type="submit"
          >
            {isSubmitting ? t('buttons.submitting') : t('buttons.subscribe')}
          </button>
        </div>
      </div>
    </form>
  );
};

export default SubscribeForm;
